import { Grid, List } from 'lucide-react'
import { Button } from '../ui/Button'
import { cn } from '../../lib/utils'

const ViewToggle = ({ view, onViewChange, className }) => {
  return (
    <div className={cn("flex items-center bg-neutral-100 rounded-lg p-1", className)}>
      <Button
        variant="ghost"
        size="sm"
        className={cn(
          "h-8 px-3 rounded-md transition-all duration-200",
          view === 'grid' 
            ? "bg-white shadow-sm text-neutral-900" 
            : "text-neutral-600 hover:text-neutral-900"
        )}
        onClick={() => onViewChange('grid')}
      >
        <Grid className="h-4 w-4 mr-1" />
        Grid
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className={cn(
          "h-8 px-3 rounded-md transition-all duration-200",
          view === 'list' 
            ? "bg-white shadow-sm text-neutral-900" 
            : "text-neutral-600 hover:text-neutral-900"
        )}
        onClick={() => onViewChange('list')}
      >
        <List className="h-4 w-4 mr-1" />
        List
      </Button>
    </div>
  )
}

export default ViewToggle
